export const widgetsCdn = {
  local: 'http://127.0.0.1:3006/v1.js',
  staging: 'https://www.handball.madebytickaroo.com/widgets/embed/v1.js',
  production: 'https://www.handball.net/widgets/embed/v1.js'
}
